import { z } from 'zod';

export const telegramValidator = z
  .string()
  .nullable()
  .refine(
    (value) => !value || /^[a-zA-Z0-9_]+$/.test(value),
    'ui.common.error.telegram'
  );
